export default function CookieFactoryIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="33" r="26" fill="#a8682e" />
      <circle cx="32" cy="31" r="25" fill="#e0a560" stroke="#8a5222" strokeWidth="3" />
      <ellipse cx="22" cy="22" rx="5" ry="4" fill="#4a2a12" />
      <ellipse cx="40" cy="19" rx="4" ry="3.2" fill="#4a2a12" />
      <ellipse cx="44" cy="35" rx="5" ry="4" fill="#4a2a12" />
      <ellipse cx="27" cy="40" rx="5.5" ry="4.2" fill="#4a2a12" />
      <ellipse cx="33" cy="29" rx="3" ry="2.4" fill="#4a2a12" />
      <ellipse cx="18" cy="33" rx="3" ry="2.4" fill="#4a2a12" />
      <path d="M14 18a22 22 0 0 1 12-9" stroke="#fff3dd" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M52 3l2.6 5.4 5.9.7-4.4 4.1 1.2 5.8L52 16.1l-5.3 2.9 1.2-5.8-4.4-4.1 5.9-.7z" fill="#ffe36b" stroke="#e08a00" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}
